import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiCheckCircle, FiExternalLink } from "react-icons/fi";
import Logo from "../components/Logo";
import PasswordInput from "../components/PasswordInput";
import api, { APP_URL } from "../services/api";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const res = await api.login(email, password);
    setLoading(false);

    if (res.ok) {
      if (res.token) localStorage.setItem("accountrix_token", res.token);
      if (res.user)
        localStorage.setItem("accountrix_user", JSON.stringify(res.user));
      if (res.user && res.user.status === "active") {
        setLoggedInUser(res.user);
      } else {
        navigate(`/pending-approval?email=${encodeURIComponent(email)}`);
      }
    } else if (res.code === "PENDING_APPROVAL") {
      navigate(`/pending-approval?email=${encodeURIComponent(email)}`);
    } else {
      setError(res.message || "Invalid email or password.");
    }
  }

  if (loggedInUser) {
    return (
      <section className="section-container flex justify-center py-20">
        <div className="card w-full max-w-md p-8 text-center">
          <FiCheckCircle className="mx-auto text-emerald-500" size={48} />
          <h1 className="mt-4 text-2xl font-bold">
            Welcome back, {loggedInUser.firstName}!
          </h1>
          <p className="mt-2 text-sm text-slate-600">
            You're signed in and your account is active.
          </p>
          <a
            href={APP_URL}
            className="btn-primary mt-6 w-full"
            rel="noreferrer"
          >
            Open Accounting App <FiExternalLink size={15} />
          </a>
        </div>
      </section>
    );
  }

  return (
    <section className="section-container flex justify-center py-20">
      <div className="card w-full max-w-md p-8">
        <div className="flex justify-center">
          <Logo withTagline={false} />
        </div>
        <h1 className="mt-6 text-center text-2xl font-bold">Welcome back</h1>
        <p className="mt-1 text-center text-sm text-slate-600">
          Log in to your Money Flow Accounting account
        </p>

        <form onSubmit={handleSubmit} className="mt-8">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-navy" htmlFor="login-email">
              Email Address
            </label>
            <input
              id="login-email"
              type="email"
              required
              className="input-field"
              placeholder="you@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="mt-5">
            <div className="mb-1.5 flex items-center justify-between">
              <label className="text-sm font-medium text-navy" htmlFor="login-password">
                Password
              </label>
              <Link
                to="/forgot-password"
                className="text-xs font-medium text-primary hover:underline"
              >
                Forgot password?
              </Link>
            </div>
            <PasswordInput
              id="login-password"
              required
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && (
            <div className="mt-5 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="btn-primary mt-6 w-full disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Log in"}
          </button>
        </form>

        <p className="mt-6 text-center text-sm text-slate-600">
          Don't have an account?{" "}
          <Link to="/register" className="font-medium text-primary hover:underline">
            Create an account
          </Link>
        </p>
      </div>
    </section>
  );
}
